/* istanbul ignore file */
import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line
    statistikPusat(_, {}) {
      return axios.get(`${API}/api/beranda_pie_pusat`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    rekapPusat(_, { params }) {
      return axios.get(`${API}/api/beranda_rekap_pusat${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    statistikPropinsi(_, { params }) {
      return axios.get(`${API}/api/beranda_pie_propinsi${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    rekapPropinsi(_, { params }) {
      return axios.get(`${API}/api/beranda_rekap_propinsi${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    statistikKota(_, { params }) {
      return axios.get(`${API}/api/beranda_pie_kota${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    rekapKota(_, { params }) {
      return axios.get(`${API}/api/beranda_rekap_kota${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    statistikKecamatan(_, { params }) {
      return axios.get(`${API}/api/beranda_pie_kecamatan${normParam(params)}`).then(res => {
        return res.data;
      });
    },

    setPMS(_, obj) {
      return axios.post(`${API}/api/set_prediksi`, obj).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    rekapKecamatan(_, { params }) {
      return axios.get(`${API}/api/beranda_rekap_kecamatan${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    rekapKelurahan(_, { params }) {
      return axios.get(`${API}/api/beranda_rekap_kelurahan${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    keteranganPropinsi(_, id) {
      if(id){
        return axios.get(`${API}/api/propinsi/${id}`).then(res => {
          return res.data;
        });
      }

    },
    // eslint-disable-next-line
    keteranganKota(_, id) {
      return axios.get(`${API}/api/kota/${id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    keteranganKecamatan(_, id) {
      return axios.get(`${API}/api/kecamatan/${id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    download({}, { params }) {
      var url = `${API}/api/warga_download${normParam(params)}`;
      window.open(url, "_blank");
      // var filename = "Data Warga SIAPBB";
      // return fetch(url, {
      //   method: "GET",
      //   headers: {
      //     "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      //   }
      // })
      //   .then(res => (res.ok ? res.blob() : Promise.reject(res)))
      //   .then(res => {
      //     const url = window.URL.createObjectURL(res);
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", `${filename}`);
      //     document.body.appendChild(link);
      //     link.click();
      //     // eslint-disable-next-line
      //     window.URL.revokeObjectURL(url);
      //   })
      //   .catch(e => {
      //     let p = e.json ? e.json().then(a => Promise.reject(a)) : Promise.reject(e);
      //     return p;
      //   })
      //   .catch(e => {
      //     //Vue.prototype.$error(e.message);
      //     return Promise.reject(e);
      //   });
    },
    // eslint-disable-next-line
    downloadRekapKota({}, { params }) {
      var url = `${API}/api/warga_download_rekap_kota${normParam(params)}`;
      window.open(url, "_blank");
      // var filename = "Data Rekap Kota";
      // return fetch(url, {
      //   method: "GET",
      //   headers: {
      //     "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      //   }
      // })
      //   .then(res => (res.ok ? res.blob() : Promise.reject(res)))
      //   .then(res => {
      //     const url = window.URL.createObjectURL(res);
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", `${filename}`);
      //     document.body.appendChild(link);
      //     link.click();
      //     // eslint-disable-next-line
      //     window.URL.revokeObjectURL(url);
      //   })
      //   .catch(e => {
      //     let p = e.json ? e.json().then(a => Promise.reject(a)) : Promise.reject(e);
      //     return p;
      //   })
      //   .catch(e => {
      //     //Vue.prototype.$error(e.message);
      //     return Promise.reject(e);
      //   });
    },
    // eslint-disable-next-line
    downloadRekapKecamatan({}, { params }) {
      var url = `${API}/api/warga_download_rekap_kecamatan${normParam(params)}`;

      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    pengurusRekapKota({}, { params }) {
      var url = `${API}/api/jabatan_rekap_kota${normParam(params)}`;

      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    pengurusRekapKecamatan({}, { params }) {
      var url = `${API}/api/jabatan_rekap_kecamatan${normParam(params)}`;

      window.open(url, "_blank");
    }
  }
};

export default store;
